import { Star, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

export const Testimonials = () => {
  const googleReviewLink = 'https://share.google/gYAFU6Se5VYqhVkLq';
  
  const happyClients = [
    {
      id: 1,
      image: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/ikult9ce_dad8abf0-4501-4af6-aff4-8e92d85a9982.jpeg',
      alt: 'Happy Client 1'
    },
    {
      id: 2,
      image: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/o6wea4aw_IMG_0404.jpeg',
      alt: 'Happy Client 2'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">
            Testimonials
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Check out authentic reviews from our satisfied clients on Google.
          </p>
        </div>

        {/* Happy Clients Gallery */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">
            Our Happy Clients
          </h3>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {happyClients.map((client) => (
              <div
                key={client.id}
                className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={client.image}
                    alt={client.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Google Reviews CTA */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-orange-600 to-orange-700 rounded-2xl p-8 md:p-12 text-center shadow-2xl">
            <div className="flex justify-center mb-6">
              <div className="flex gap-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="text-yellow-400 fill-yellow-400" size={40} />
                ))}
              </div>
            </div>
            <h3 className="text-3xl font-bold text-white mb-4">
              Love Our Work? Share Your Experience!
            </h3>
            <p className="text-orange-100 text-lg mb-8 max-w-2xl mx-auto">
              Your feedback helps us improve and helps others find quality home solutions. 
              Leave us a review on Google or check out what others are saying.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                onClick={() => window.open(googleReviewLink, '_blank')}
                size="lg"
                className="bg-white text-orange-600 hover:bg-orange-50 text-lg px-8 py-6 transition-all duration-200 hover:scale-105 shadow-lg"
              >
                <Star className="mr-2" size={20} />
                Leave a Google Review
              </Button>
              <Button
                onClick={() => window.open(googleReviewLink, '_blank')}
                size="lg"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white/10 text-lg px-8 py-6 transition-all duration-200 hover:scale-105"
              >
                View All Reviews
                <ExternalLink className="ml-2" size={20} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};